import './modules/menu-collapsible.js';
import './modules/menu-multilevel.js';

(function($){

  var bodyIdPrefix = 'catalog-category-';
  var id = $('body').attr('id').substr(bodyIdPrefix.length);
  var active = null;
  var $menu = $('.menu-collapsible');

  if($menu.find('.mainCategory.'+id).length > 0) {
    active = $menu.find('.mainCategory.'+id+' .menu-link');
    active.addClass('active')
          .parentsUntil('.mc-menu')
          .children('.menu-link')
            .addClass('active');
  } else {
    var parentLinks = $menu.find('.menu-item.'+id).parents('.menu-item').children('.menu-link');
    parentLinks.addClass('active');
  }

  $('nav.category.menu-collapsible').menuCollapsible({});

  $('nav.category.menu-multilevel').menuMultiLevel({});

})(jQuery);



// WEBPACK FOOTER //
// ./grails-app/assetsSrc/scripts/category.js